/*@flow*/
import React from 'react';
import TextEditor from 'comps/TextEditor';
import isSmallScreen from 'lib/isSmallScreen';
import textbox from 'lib/proforma/templates/Textbox';

export default (textbox.clone({
  Textarea({
    onChange,
    value,
    attrs,
  }: {
    onChange: Function,
    value: any,
    attrs: { name: string },
  }) {
    const v = value || '';
    // TextEditor generates random identifiers, which causes
    // flakiness in snapshot tests. So we replace it with a simple
    // textarea in test mode.
    //
    // In addition, it jumps around on small screens. We replace it for those as well.
    return process.env.NODE_ENV === 'test' || isSmallScreen() ? (
      <textarea
        value={v}
        name={attrs.name}
        onChange={v2 => {
          onChange(v2.target.value);
        }}
        className="form-control"
      />
    ) : (
      <TextEditor value={v} name={attrs.name} onChange={v2 => onChange(v2)} />
    );
  },
}): any);
